import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=103bcaa6&scoped=true&"
import script from "./Treatment.vue?vue&type=script&lang=js&"
export * from "./Treatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103bcaa6",
  null
  
)

export default component.exports